import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { smoothScrollTo } from "./smoothScroll";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (navType !== "POP" && location.pathname !== prevPathname.current) {
      prevPathname.current = location.pathname;
      return smoothScrollTo(0);
    }
    prevPathname.current = location.pathname;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, navType]);

  return null;
}

export default ScrollToTop;
